import api from './api';

const financeService = {
  // Get all milk sales
  getAllMilkSales: async () => {
    const response = await api.get('/api/finance/milk-sales');
    return response.data;
  },

  // Get milk sale by ID
  getMilkSaleById: async (id) => {
    const response = await api.get(`/api/finance/milk-sales/${id}`);
    return response.data;
  },

  // Create milk sale
  createMilkSale: async (saleData) => {
    const response = await api.post('/api/finance/milk-sales', saleData);
    return response.data;
  },
    // Update milk sale
updateMilkSale: async (id, saleData) => {
  const response = await api.put(`/api/finance/milk-sales/${id}`, saleData);
  return response.data;
},

// Delete milk sale
deleteMilkSale: async (id) => {
  const response = await api.delete(`/api/finance/milk-sales/${id}`);
  return response.data;
},

  // Record payment
  recordPayment: async (paymentData) => {
    const response = await api.post('/api/finance/payments', paymentData);
    return response.data;
  },

  // Get customer transactions
  getCustomerTransactions: async (customerId, days = 30) => {
    const response = await api.get(`/api/finance/customers/${customerId}/transactions?days=${days}`);
    return response.data;
  },

  // Get finance stats
  getFinanceStats: async () => {
    const response = await api.get('/api/finance/stats');
    return response.data;
  },
};

export default financeService;